import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">For technical support please contact <b><a href="mailto:it.helpdesk@aub.edu.lb?subject=SC Elections Technical Support">IT Helpdesk</a></b></span>
    <div class="socials">
      <a href="https://www.snapchat.com/add/aub_lebanon" target="_blank" class="ion ion-social-snapchat"></a>
      <a href="https://www.facebook.com/aub.edu.lb" target="_blank" class="ion ion-social-facebook"></a>
      <a href="https://twitter.com/AUB_Lebanon" target="_blank" class="ion ion-social-twitter"></a>
      <a href="https://www.linkedin.com/company/american-university-of-beirut" target="_blank" class="ion ion-social-linkedin"></a>
      <a href="https://plus.google.com/+AUBatLebanon" target="_blank" class="ion ion-social-googleplus"></a>
      <a href="http://instagram.com/aub_lebanon" target="_blank" class="ion ion-social-instagram"></a>
      <a href="http://www.youtube.com/AUBatLebanon" target="_blank" class="ion ion-social-youtube"></a>
    </div>
  `,
})
export class FooterComponent {
}


// WEBPACK FOOTER //
// ./src/app/@theme/components/footer/footer.component.ts